import React, { useCallback, useEffect, useState } from 'react';
import styles from './ChangeTimeLimit.module.scss';
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../miscellaneous/Modal/Modal";
import { $t } from "../../../helpers/translator";
import { setAlert } from "../../../store/alerts-slice";
import { BiEdit } from "react-icons/bi";
import Tooltip from '../../miscellaneous/Tooltip/Tooltip';
import DateSelector from '../../miscellaneous/DateSelector/DateSelector';
import moment from 'moment';
import { checkIsUnlimited } from "../PlatformTimeLimit";

const ChangeTimeLimit = (props) => {
    const user = useSelector(state => state.auth.user)

    const { platform, userType, editPlatform, setUpdatedBy } = props;
    const timeLimitKey = userType === 5 ? 'time_limit_alma' : 'time_limit';

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ timeLimit, setTimeLimit ] = useState(platform[ timeLimitKey ] ? moment(platform[ timeLimitKey ]) : null);

    const getMaxDate = useCallback(() => {
        if (userType === 5) {
            return moment().add(3, 'year');
        } else {
            const isAlmaUnlimited = checkIsUnlimited('time_limit_alma', platform);
            if (isAlmaUnlimited) {
                return moment().add(3, 'year');
            } else {
                if (platform.time_limit_alma) {
                    return moment(platform.time_limit_alma);
                }
            }
        }
    }, [ userType, platform ]);


    const onDateChange = (date) => {
        const dateObject = date.toDate();
        const day = dateObject.getDate().toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        const month = (dateObject.getMonth() + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        const year = dateObject.getFullYear();
        const dateValue = moment(`${year}-${month}-${day}`).format('YYYY-MM-DD');
        // console.log(date.toDate(), date.format('YYYY-MM-DD'), dateValue);
        setTimeLimit(dateValue);
    }

    async function updatePlatform() {
        if (timeLimit) {
            const payload = {
                [ timeLimitKey ]: timeLimit.format('YYYY-MM-DD')
            };

            if (userType === 5) {
                if (platform.time_limit && moment(platform.time_limit).isAfter(timeLimit)) {
                    payload.time_limit = timeLimit.format('YYYY-MM-DD')
                }
            }

            editPlatform(platform, payload).then(() => {
                setUpdatedBy({
                    user_name: user?.name,
                    last_change: moment().format('YYYY-MM-DD HH:mm:ss')
                });
                setShowModal(false);
            })
            console.log(payload);
        } else {
            // Alert that time limit is required
            dispatch(setAlert({
                type: 'error',
                message: $t('global.machines.timeLimitRequired')
            }));
        }

    }

    function renderModalContent() {
        return (
            <div>
                <div className={ 'alma-box-header' }>
                    <div>
                        <h3 style={ {
                            margin: 0,
                            marginBottom: 10
                        } }>
                            { $t('global.machines.changeTimeLimit') }
                        </h3>
                    </div>
                </div>
                <div className={ 'alma-box-content' }>
                    <div className={ 'alma-field-container' }>
                        <div className={ 'alma-field-header' }>
                            { $t('global.machines.timeLimit') }
                        </div>
                        { <DateSelector maxDate={ getMaxDate() }
                            onDateChange={ onDateChange }
                            selected={ timeLimit } /> }
                    </div>
                </div>
                <div className={ 'alma-box-footer' }>
                    <div />
                    <div className={ 'alma-button' } onClick={ () => updatePlatform() }>
                        { $t('global.machines.save') }
                    </div>

                </div>
            </div>
        )
    }

    useEffect(() => {
        setTimeLimit(platform[ timeLimitKey ] ? moment(platform[ timeLimitKey ]) : null);
    }, [ platform, timeLimitKey ]);


    return (
        <div className={ `${styles[ 'container' ]}` }>

            <div className={ styles.flexRow }>
                <Tooltip content={ $t('global.machines.changeTimeLimit') }>
                    <button className={ styles.button }
                        onClick={ () => setShowModal(true) }>
                        <BiEdit />
                    </button>
                </Tooltip>
            </div>

            <Modal content={ renderModalContent() }
                onClose={ async () => {
                    setShowModal(false);
                } }
                visible={ showModal } />
        </div>
    );
}


export default ChangeTimeLimit;
